const initialState = {
  info: {},
};

export function setTreeLimit(payload) {
  return {
    type: 'SELECTDLIMITCODE',
    payload,
  };
}

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'SELECTDLIMITCODE': {
      return Object.assign({}, state, { info: payload });
    }
    default:
      return state;
  }
};
